module.exports = __webpack_public_path__ + "static/media/WhiteLogo_ME_1.3daf0c07.svg";